import { Pipe, PipeTransform } from '@angular/core';
// TODO: move directly to sales-force-account
@Pipe({
    name: 'salesForceAccountMappingFilter',
    standalone: false
})
export class SalesForceAccountMappingPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) {
            return [];
        }

        if (!searchText) {
            return items;
        }

        searchText = searchText.toLowerCase();

        return items.filter((val) => {
            return (val.name.toLocaleLowerCase().includes(searchText)) || (val.jobTitle.toLocaleLowerCase().includes(searchText) || (val.companyName.toLocaleLowerCase().includes(searchText)));
        })
    }

}
